<template>
	<ul class="buttons-do">
		<li @click="changeMode(true)"><i class="fa fa-th-large" aria-hidden="true"></i></li>
		<li @click="changeMode(false)" class="border-del"><i class="fa fa-list-ul" aria-hidden="true"></i></li>
	</ul>




</template>

<script>

    //Vue.use(Vuex)

    export default {
    	name: 'mode',
    	data() {
    		return {
                //mode: true
    		}
    	},
    	computed: {
    		// mode() {
    		// 	return this.$store.getters.getMode
    		// },

    	},

    	methods: {
    		// async fileInputChange() {
    		// 	let files = Array.from(event.target.files)

    		// 	eventBus.$emit("uploads", files);

    		// },


    		// openModalCreateFolder(){
    		// 	this.$store.dispatch('openModalCreateFolder')
    		// },
    		// changeMode(value){
    		// 	this.$store.dispatch('changeMode', value)

    		// },

    	},

    }

</script>

<style scoped>

h1 {
	font-weight: 700;
	font-size: 15px;
	color: #707070;
}
/*! CSS Used from: https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css */
*,::after,::before{box-sizing:border-box;}
nav{display:block;}
ul{margin-top:0;margin-bottom:1rem;}
a{color: #333;text-decoration:none;background-color:transparent;}
a:hover{color: #333;text-decoration:underline;}
h1{margin-bottom:.5rem;font-weight:500;line-height:1.2;}
h1{font-size:2.5rem;}
@media print{
	*,::after,::before{text-shadow:none!important;box-shadow:none!important;}
	a:not(.btn){text-decoration:underline;}
}
/*! CSS Used from: http://localhost:3000/css/home.css */
.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}
a:hover{text-decoration:none;}
li{list-style:none;font-size:15px;}
.pb10{padding-bottom:10px;}
.mb30{margin-bottom:30px;}
ul{padding:0;}
.breadcrumbs li{display:inline-block;}
.breadcrumbs li > span > i{font-size:9px;color:#707070;}
.breadcrumbs li > h1{font-weight: 700;
	font-size: 15px;
	color: #707070;}
	.breadcrumbs li > .activepage{font-weight:bold;}
	 li{display:inline-block;font-size:12px;margin-left:14px;}
	 li:hover{cursor:pointer;}
	 li i{color:#707070;padding:5px;border-radius:3px;}
	.content h1{font-weight:700;font-size:15px;color:#707070;}
	.nav-page{border-bottom:2px solid #ddd;margin-bottom:0px;}
	.nav-page li{display:inline-block;margin-right:24px;}
	.nav-page li a{color:#707070;font-size:13px;}
	.active-nav-page-a{color:#333;}
	.border-del{border-left:1px solid #ccc;margin-left:0!important;}


</style>


// WEBPACK FOOTER //
// src/components/layouts/mode.vue